import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { useEffect, useState } from "react";
import {
  GetAllAcademicRank,
  GetAllCountry,
  SetCurrentJobInformationSpecializationState,
} from "../../../Redux/Reducers/Submitter/CurrentJobInformationSpecialization";

const CurrentWorkSpecialtyInformation = (props) => {
  const dispatch = useDispatch();
  const [editValue, setEditValue] = useState(null);
  const [editText, setEditText] = useState(null);
  const ValidationWorkAndEducationInformationResultLsist = useSelector(
    (state) =>
      state.WorkAndEducationInformationValidation
        .ValidationWorkAndEducationInformation
  );

  const ValiationList =
    ValidationWorkAndEducationInformationResultLsist?.result?.map(
      (ele) => ele.code
    );
  const lang = useSelector((state) => state.languageReducer.Language);
  const AllCountry = useSelector(
    (state) => state.CurrentJobInformationSpecialization.Country
  );
  const AllAcademicRank = useSelector(
    (state) => state.CurrentJobInformationSpecialization.AcademicRank
  );

  const currentJobInformationSpecialization = useSelector(
    (state) =>
      state.CurrentJobInformationSpecialization
        .CurrentJobInformationSpecialization
  );
  console.log(AllCountry, "AllCountry");

  useEffect(() => {
    dispatch(
      GetAllCountry({
        isEn: lang === "en" ? true : false,
      })
    );
    dispatch(
      GetAllAcademicRank({
        isEn: lang === "en" ? true : false,
      })
    );
  }, []);

  console.log(
    props.currentJobInformationSpecialization,
    "currentJobInfssddormationSpecialization"
  );

  return (
    <>
      {props.currentJobInformationSpecialization
        ?.currentJobInformationSpecializationId ? (
        <>
          <div className="form-grid">
            <AllDropDownsAHSF
              fieldsName="CountryCurrentWorkSpecialtyInformation"
              hidelable={false}
              lang={lang}
              key={lang}
              disabled={props.disabled}
              show={true}
              valueEdite={currentJobInformationSpecialization?.countryId}
              submissionStatus={"edite"}
              textEdite={
                lang === "ar"
                  ? currentJobInformationSpecialization?.countryNameAr
                  : currentJobInformationSpecialization?.countryNameEn
              }
              arrayOoptionList={AllCountry}
              KeyText={lang === "ar" ? "countryNameAr" : "countryNameEn"}
              id={"countryId"}
              dropdownType={"search"}
              defaultValue={currentJobInformationSpecialization?.countryId}
              value={currentJobInformationSpecialization?.countryId}
              OnClickLi={(e) => {
                // props.setCountryId(e.countryId);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    countryId: e.countryId,
                  })
                );
                setEditValue(e.countryId);
                setEditText(lang === "ar" ? e.countryNameAr : e.countryNameEn);
              }}
              showValidationMessage={
                ValiationList?.includes(
                  "CountryCurrentWorkSpecialtyInformation"
                )
                  ? true
                  : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />

            <InputAHSF
              fieldsName="CityCurrentWorkSpecialtyInformation"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={currentJobInformationSpecialization?.city}
              onChange={(e) => {
                // props.setCity(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    city: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("CityCurrentWorkSpecialtyInformation")
                  ? true
                  : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
            <InputAHSF
              fieldsName="UniversityInstitution"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={
                currentJobInformationSpecialization?.university_Institution
              }
              onChange={(e) => {
                // props.setuniversity_Institution(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    university_Institution: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("UniversityInstitution") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
            <InputAHSF
              fieldsName="College"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={currentJobInformationSpecialization?.college}
              onChange={(e) => {
                // props.setCollege(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    college: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("College") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
            <InputAHSF
              fieldsName="Section"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={currentJobInformationSpecialization?.department}
              onChange={(e) => {
                // props.SetDepartment(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    department: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("Section") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
            <InputAHSF
              fieldsName="JobTitle"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={currentJobInformationSpecialization?.jobTitle}
              onChange={(e) => {
                // props.setJobTitle(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    jobTitle: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("JobTitle") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
            <AllDropDownsAHSF
              fieldsName="ScientificRank"
              hidelable={false}
              disabled={props.disabled}
              //   labelName={"الجنسية"}
              lang={lang}
              show={true}
              valueEdite={currentJobInformationSpecialization?.academicRankId}
              submissionStatus={"edite"}
              textEdite={
                lang === "ar"
                  ? currentJobInformationSpecialization?.academicRankNameAr
                  : currentJobInformationSpecialization?.academicRankNameEn
              }
              arrayOoptionList={AllAcademicRank}
              KeyText={
                lang === "ar" ? "academicRankNameAr" : "academicRankNameEn"
              }
              id={"academicRankId"}
              dropdownType={"search"}
              defaultValue={currentJobInformationSpecialization?.academicRankId}
              value={props.currentJobInformationSpecialization?.academicRankId}
              OnClickLi={(e) => {
                // props.setAcademicRankId(e.academicRankId);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    academicRankId: e.academicRankId,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("ScientificRank") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />

            <InputAHSF
              fieldsName="GeneralSpecialization"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={
                currentJobInformationSpecialization?.generalSpecialization
              }
              onChange={(e) => {
                // props.setGeneralSpecialization(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    generalSpecialization: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("GeneralSpecialization") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
            <InputAHSF
              fieldsName="Subspecialization"
              show={true}
              lang={lang}
              disabled={props.disabled}
              defaultValue={
                currentJobInformationSpecialization?.subspecialization
              }
              onChange={(e) => {
                // props.setsubspecialization(e.target.value);
                dispatch(
                  SetCurrentJobInformationSpecializationState({
                    ...currentJobInformationSpecialization,
                    subspecialization: e.target.value,
                  })
                );
              }}
              showValidationMessage={
                ValiationList?.includes("Subspecialization") ? true : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default CurrentWorkSpecialtyInformation;
